import Vue from 'vue'
import env from '../services/environment'

let apiPath = 'https://' + env.apiTargetPath + env.apiPrefix

export default {
  getMySites: function () {
    let apiDetailPath = '/sites'
    return Vue.http.get(apiPath + apiDetailPath, { 'headers': {'Authorization': 'Bearer ' + Vue.auth.idToken} })
  },
  getSite: function (siteId) {
    let apiDetailPath = '/sites/' + siteId
    return Vue.http.get(apiPath + apiDetailPath, { 'headers': {'Authorization': 'Bearer ' + Vue.auth.idToken} })
  },
  getSiteCameras: function (siteId) {
    let apiDetailPath = '/sites/' + siteId + '/devices/cameras'
    return Vue.http.get(apiPath + apiDetailPath, { 'headers': {'Authorization': 'Bearer ' + Vue.auth.idToken} })
  },
  getSiteMembers: function (siteId) {
    let apiDetailPath = '/sites/' + siteId + '/members'
    return Vue.http.get(apiPath + apiDetailPath, { 'headers': {'Authorization': 'Bearer ' + Vue.auth.idToken} })
  },
  getSiteContacts: function (siteId) {
    let apiDetailPath = '/sites/' + siteId + '/contacts'
    return Vue.http.get(apiPath + apiDetailPath, { 'headers': {'Authorization': 'Bearer ' + Vue.auth.idToken} })
  }
}



// WEBPACK FOOTER //
// ./src/api/site.js